import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function percentRangeValidator(min = 1, max = 100): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const rawValue = control.value.toString().replace('%', '');
    const value = Number(rawValue);

    if (isNaN(value)) return { invalidNumber: true };

    if (value < min || value > max) {
      return { outOfRange: { min, max, actual: value } };
    }

    return null;
  };
}
